'use client';

import { Box, Group } from '@mantine/core';
import { ChatFloatingWindowConversationMenu } from './chat-floating-window-conversation-menu';
import { ChatFloatingWindowRoom } from './chat-floating-window-room';

interface IChatFloatingWindowProps {
  onClose?: () => void;
}

export function ChatFloatingWindow({ onClose }: IChatFloatingWindowProps) {
  return (
    <Box w="48rem" h="28rem" bg="white" className="shadow-xl" bdrs="md">
      <Group gap={0} wrap="nowrap" h="100%" align="start">
        <ChatFloatingWindowConversationMenu />
        <Box flex={1} h="100%">
          <ChatFloatingWindowRoom onClose={onClose} />
        </Box>
      </Group>
    </Box>
  );
}
